document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
    const productCards = document.querySelectorAll('.boost-sd__product-list .product-card');
    productCards.forEach((card, index) => {
      const badge = card.querySelector('.product-badge-full');
      if (badge) {
        if (index < 4) {
          badge.style.display = 'grid';
        } else {
          badge.remove();
        }
      }
    });
  }, 2000);
});

window.onload = function () {
  const productCards = document.querySelectorAll('.boost-sd__product-list .product-card');
  productCards.forEach((card, index) => {
    const badge = card.querySelector('.product-badge-full');
    if (badge) {
      if (index < 4) {
        badge.style.display = 'grid';
      } else {
        badge.remove();
      }
    }
  });

  setTimeout(function() {
    const productCards = document.querySelectorAll('.boost-sd__product-list .product-card');
    productCards.forEach((card, index) => {
      const badge = card.querySelector('.product-badge-full');
      if (badge) {
        if (index < 4) {
          badge.style.display = 'grid';
        } else {
          badge.remove();
        }
      }
    });
  }, 200);
};